
import { mediaQueryLarge } from '@theme/utilities';
import PaginatedList from '@theme/paginated-list';

export default class ResultsList extends PaginatedList {
  connectedCallback() {
    super.connectedCallback();

    mediaQueryLarge.addEventListener(
      'change',
      this.#handleMediaQueryChange
    );

    this.addEventListener(
      'change',
      this.#handleGridDensityChange
    );

    this.setAttribute('initialized', '');

    requestAnimationFrame(() => this.#restoreLayout());
  }

  disconnectedCallback() {
    super.disconnectedCallback?.();

    mediaQueryLarge.removeEventListener(
      'change',
      this.#handleMediaQueryChange
    );

    this.removeEventListener(
      'change',
      this.#handleGridDensityChange
    );
  }

  getGrid() {
    return (
      this.querySelector('[data-product-grid]') ||
      this.querySelector('.product-grid') ||
      this.refs?.grid
    );
  }

  updateLayout({ target }) {
    if (!(target instanceof HTMLInputElement)) return;
    if (!target.matches('.column-options__option-input')) return;

    this.#applyLayout(target.value, true);
  }

  #handleGridDensityChange = (event) => {
    const target = event.target;

    if (!(target instanceof HTMLInputElement)) return;
    if (!target.matches('.column-options__option-input')) return;

    this.#applyLayout(target.value, true);
  };

  #handleMediaQueryChange = () => {
    this.#restoreLayout();
  };

  #restoreLayout = () => {
    const viewport = mediaQueryLarge.matches ? 'desktop' : 'mobile';

    const allowed = viewport === 'desktop'
      ? ['default', 'zoom-out']
      : ['default', 'mobile-single'];

    let value = 'default';

    try {
      const saved = sessionStorage.getItem(
        `product-grid-view-${viewport}`
      );

      if (allowed.includes(saved)) {
        value = saved;
      }
    } catch (error) {
      // Storage may be unavailable.
    }

    this.#applyLayout(value, false);
  };

  #applyLayout(value, persist) {
    const viewport = mediaQueryLarge.matches ? 'desktop' : 'mobile';

    const allowed = viewport === 'desktop'
      ? ['default', 'zoom-out']
      : ['default', 'mobile-single'];

    if (!allowed.includes(value)) return;

    const grid = this.getGrid();

    if (!grid) {
      console.warn('TNO: product grid not found');
      return;
    }

    grid.setAttribute('product-grid-view', value);

    const name = viewport === 'desktop'
      ? 'grid'
      : 'grid-mobile';

    this.querySelectorAll(`input[name="${name}"]`).forEach((input) => {
      if (input instanceof HTMLInputElement) {
        input.checked = input.value === value;
      }
    });

    if (persist) {
      try {
        sessionStorage.setItem(
          `product-grid-view-${viewport}`,
          value
        );
      } catch (error) {
        // Storage may be unavailable.
      }
    }
  }
}

if (!customElements.get('results-list')) {
  customElements.define('results-list', ResultsList);
}
